<template>
  <div class="btn-get-slides" @click="showqna()">
    <img
      src="@/assets/images/icon-download.svg"
      class="icon-download"
    > <span>{{ $t('Get slides') }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// utils
import utils from '@/util'

// UI

export default {
  components: {
  },
  propsData: ['variant'],
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    showqna() {
      this.$store.state.showRequestPresentation = true
      utils.gaTrackEvent(
        'Audience',
        'Last slide > Button CTA > Request presentation share',
        '',
        '',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-get-slides {
  color: #fff;
  font-size: 14px;
  position: relative;
  span {
    margin-right: -17px;
  }
}

.icon-download {
  position: absolute;
  margin-left: -18px;
}
.audience-cta__link {
  color: #257adc;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}
.audience-cta.cta-leaderboard {
  box-shadow: none;
  background-color: transparent;
  padding-top: 0;
  margin-bottom: 16px;
  .audience-cta__link {
    color: inherit;
    font-weight: normal;
    span {
      text-decoration: underline;
    }
  }
}
.cta-question-default {
  box-shadow: none;
  background-color: transparent;
  padding-top: 0;
}
</style>
